'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('./utils/polyfill');

var _compactObject = require('./utils/compact-object');

var _compactObject2 = _interopRequireDefault(_compactObject);

var _normalizeUrl = require('./utils/normalize-url');

var _normalizeUrl2 = _interopRequireDefault(_normalizeUrl);

var _appendParams = require('./utils/append-params');

var _appendParams2 = _interopRequireDefault(_appendParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PARSE_ERROR_RESPONSE = { message: 'PARSE_ERROR' };
var DEFAULT_AUTHORIZATION_KEYWORD = 'Token ';
var DEFAULT_AUTHORIZATION_HEADER = 'Authorization';
var handleParseError = function handleParseError(error) {
  return Promise.reject(_extends({}, PARSE_ERROR_RESPONSE, { error: error }));
};

var FETCH_DEFAULTS = {
  headers: {
    'Content-type': 'application/json; charset=UTF-8'
  }
};

var contentTypeIsJSON = function contentTypeIsJSON(header) {
  return header && header.includes('application/json');
};

var Fetch = function () {
  function Fetch(defaultURL, defaults) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Fetch);

    this.defaultURL = defaultURL;
    this.defaults = defaults || FETCH_DEFAULTS;
    this.options = options;
  }

  _createClass(Fetch, [{
    key: 'buildAuthorizationHeader',
    value: function buildAuthorizationHeader(key) {
      if (key) {
        var authKeyword = this.options.defaultAuthorizationKeyword === undefined ? DEFAULT_AUTHORIZATION_KEYWORD : this.options.defaultAuthorizationKeyword;
        var authHeader = this.options.defaultAuthorizationHeader || DEFAULT_AUTHORIZATION_HEADER;
        return _defineProperty({}, authHeader, '' + authKeyword + key);
      }
      return {};
    }
  }, {
    key: 'request',
    value: function request(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var headers = options.headers,
          key = options.key,
          noBaseURL = options.noBaseURL,
          removeTrailingSlash = options.removeTrailingSlash,
          params = options.params,
          opts = _objectWithoutProperties(options, ['headers', 'key', 'noBaseURL', 'removeTrailingSlash', 'params']);

      var authorization = this.buildAuthorizationHeader(key);
      var finalURL = this.getURL(url, {
        noBaseURL: noBaseURL,
        removeTrailingSlash: removeTrailingSlash || this.options.removeTrailingSlash
      }, params);

      var _defaults = this.defaults,
          defaultHeaders = _defaults.headers,
          defaults = _objectWithoutProperties(_defaults, ['headers']);

      return fetch(finalURL, _extends({}, opts, defaults, {
        headers: (0, _compactObject2.default)(_extends({}, defaultHeaders, authorization, headers))
      })).then(function (response) {
        if (contentTypeIsJSON(response.headers.get('content-type'))) {
          return Promise.all([response.json(), response.ok]);
        }
        return Promise.all([response.text(), response.ok]);
      }).catch(handleParseError).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            response = _ref3[0],
            ok = _ref3[1];

        if (!ok) {
          return Promise.reject(response);
        }
        return Promise.resolve(response);
      });
    }
  }, {
    key: 'getURL',
    value: function getURL(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (options.noBaseURL) {
        return (0, _appendParams2.default)((0, _normalizeUrl2.default)(url)(options), params, options);
      }

      return (0, _appendParams2.default)((0, _normalizeUrl2.default)(this.defaultURL, url)(options), params, options);
    }
  }, {
    key: 'get',
    value: function get(url, options) {
      return this.request(url, options);
    }
  }, {
    key: 'createRequest',
    value: function createRequest(method, url, options, body) {
      return this.request(url, _extends({}, options, {
        method: method,
        body: JSON.stringify(body)
      }));
    }
  }, {
    key: 'post',
    value: function post(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = arguments[2];

      return this.createRequest('POST', url, options, body);
    }
  }, {
    key: 'patch',
    value: function patch(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = arguments[2];

      return this.createRequest('PATCH', url, options, body);
    }
  }, {
    key: 'put',
    value: function put(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = arguments[2];

      return this.createRequest('PUT', url, options, body);
    }
  }, {
    key: 'delete',
    value: function _delete(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body = arguments[2];

      return this.createRequest('DELETE', url, options, body);
    }
  }, {
    key: 'upload',
    value: function upload(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var formData = arguments[2];

      return this.request(url, _extends({
        method: 'POST'
      }, options, {
        body: formData,
        headers: {
          'Content-type': undefined
        }
      }));
    }
  }], [{
    key: 'api',
    value: function api(defaultURL, defaultHeaders, options) {
      return new Fetch(defaultURL, defaultHeaders, options);
    }
  }]);

  return Fetch;
}();

exports.default = Fetch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/index.js
// module id = 583
// module chunks = 0